module.exports = __webpack_public_path__ + "static/media/icon-supplies-earring-hole-cleaner.fb50d267.svg";